module.exports = __webpack_public_path__ + "img/Jonas.33642242.jpg";